// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__x-yjg","subContainer":"styles_subContainer__1qUQI"};